import styled from '@emotion/styled/macro';

export const Error = styled.div`
  justify-content: center;
  margin: 60px;
  display: flex;
  font-size: 35px;
  color: #bdbdbd;
`;
